import { useEffect, useState } from "react";
import axios from "axios";
import ProduitsTable from "./ProduitsTable";
import ProduitsModal from "./ProduitsModal";
import ProduitsForm from "./ProduitsForm";
import ExportButton from "./ExportButton";
import SearchBar from "./SearchBar";
import { PlusIcon } from "@heroicons/react/24/solid";
import { useAuth } from "../../context/AuthProvider";


export default function Produits() {
  const { user } = useAuth();
  const [produits, setProduits] = useState([]);
  const [produitsFiltrés, setProduitsFiltrés] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [produitSelectionne, setProduitSelectionne] = useState(null);
  const [openFicheProduit, setOpenFicheProduit] = useState(false);
  const [openEdition, setOpenEdition] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchProduits();
  }, []);

  const BACKEND_URL =
    window.location.hostname === "localhost"
      ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
      : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

  const fetchProduits = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${BACKEND_URL}/produits`);
      console.log("📊 Produits récupérés :", res.data.produits.length);
      setProduits(res.data.produits || []);
      setProduitsFiltrés(res.data.produits || []);
    } catch (err) {
      console.error("❌ Erreur lors de la récupération des produits :", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6">
      {/* 🔍 Barre du haut : recherche + exporter + ajouter */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
        <div className="flex-1">
          <SearchBar produits={produits} setProduitsFiltrés={setProduitsFiltrés} />
        </div>

        <div className="flex gap-3 items-center justify-end">
          <ExportButton selectedRows={selectedRows} produits={produitsFiltrés} />

          <button
            onClick={() => {
              setProduitSelectionne(null);
              setOpenForm(true);
            }}
            className="inline-flex items-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500"
          >
            <PlusIcon className="h-5 w-5" />
            Ajouter
          </button>
        </div>
      </div>

      {/* 📄 Tableau des produits */}
      <ProduitsTable
        produits={produitsFiltrés}
        setSelectedRows={setSelectedRows}
        setProduitSelectionne={setProduitSelectionne}
        setOpenFicheProduit={setOpenFicheProduit}
        setOpenEdition={setOpenEdition}
        setOpenDeleteModal={setOpenDeleteModal}
        isLoading={isLoading}
        userRole={user?.Rôle}
      />

      {/* 🧾 Fiche produit */}
      <ProduitsModal
        produitSelectionne={produitSelectionne}
        setProduitSelectionne={setProduitSelectionne}
        openFicheProduit={openFicheProduit}
        setOpenFicheProduit={setOpenFicheProduit}
        openEdition={openEdition}
        setOpenEdition={setOpenEdition}
        fetchProduits={fetchProduits}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
      />

      {/* 📝 Formulaire produit */}
      <ProduitsForm
        open={openForm}
        setOpen={setOpenForm}
        produitSelectionne={produitSelectionne}
        fetchProduits={fetchProduits}
      />
    </div>
  );
}
